import React, { useState, useEffect, useRef, use } from 'react';
import { FaHome, FaUserCircle , FaSignOutAlt} from 'react-icons/fa'; // Importing icons
import logo from '../assets/logo192.png';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setUserDetails } from '../redux/userSlice';
import ProfileModal from './ProfileModal';
import api from '../api/api';
import useProfileStore from '../Zustand/useProfileStore';
import HelpIcon from '@mui/icons-material/Help';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import AiSupportChat from '../global/AiSupportChat';
import AiVectorSupportChat from '../global/AiVectorSupportChat';
import { logActivity, flushActivity } from '../utils/activityLogger';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import ApprovalRequestsModal from '../Users/ApprovalRequests';
import Toast from '../global/toastmessage';
import { isSuperAdminUser } from '../utils/roles';
const MainHeader = () => {
    const [aiChatOpen, setAiChatOpen] = useState(false);
    const [aiVectorChatOpen, setAiVectorChatOpen] = useState(false);
    const [isApprovalModalOpen, setIsApprovalModalOpen] = useState(false);
    const [pendingApprovals, setPendingApprovals] = useState(0);
    const [toast, setToast] = useState({ open: false, message: '', severity: 'success' });
    const [isProfileMenuOpen, setProfileMenuOpen] = useState(false);
    const profileMenuRef = useRef(null); // Ref for the profile menu
    const [showModal, setShowModal] = useState(false);
    const imageUrl = useProfileStore((state) => state.imageUrl);
    const setImageUrl = useProfileStore((state) => state.setImageUrl);
    const navigate = useNavigate();
      const user = useSelector(state => state.user.userDetails);
        const [token, setToken] = useState(null);
    const dispatch = useDispatch();
  const location =useLocation()
    const handleLogout = async () => {
      // Record the logout while the token is still valid, then flush.
      logActivity('LOGOUT', { target: 'Sign Out' });
      try { await flushActivity(); } catch (e) { /* never block logout */ }
      sessionStorage.removeItem('accessToken'); // Clear the token
      dispatch(setUserDetails(null));         // Optional: Clear user data in redux
      navigate('/');                          // Redirect to login or home
    };
 useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const accessToken = queryParams.get('allow');

    if (accessToken) {
      setToken(accessToken);

    }
  }, [location.search]);
  // ✅ Fetch latest profile image with cache-busting
const checkProfileImage = (userId) => {
  const cacheBuster = new Date().getTime();
  const profileImgUrl = `https://hub2.ntactops.com/ntact/files/user_profiles/${userId}_profile.png?cb=${cacheBuster}`;
  const img = new Image();

  img.onload = () => setImageUrl(profileImgUrl);
  img.onerror = () => setImageUrl(null);
  img.src = profileImgUrl;
};
useEffect(() => {
  if (user?.id) {
    checkProfileImage(user.id);
  }
}, [user,]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (profileMenuRef.current && !profileMenuRef.current.contains(event.target)) {
                setProfileMenuOpen(false); // Close menu if clicked outside
            }
        };

        // Add event listener
        document.addEventListener('mousedown', handleClickOutside);

        // Cleanup the event listener on component unmount
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // --- User delete approval queue (Super Admin only) ---
    const isSuperAdmin = isSuperAdminUser(user);

    const showToast = (message, severity = 'success') =>
        setToast({ open: true, message, severity });

    const fetchPendingApprovals = async () => {
        if (!isSuperAdmin || token) return;
        try {
            const response = await api.get('/v1/user-approvals?status=P');
            setPendingApprovals((response.data || []).length);
        } catch (error) {
            console.error('Failed to fetch pending approvals:', error);
        }
    };

    // Refetch on navigation so the badge stays current without polling.
    useEffect(() => {
        fetchPendingApprovals();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSuperAdmin, token, location.pathname]);

    const toggleProfileMenu = () => {
        setProfileMenuOpen((prev) => !prev); // Toggle the dropdown menu
    };
    


    return (
        <header className="flex items-center justify-between p-4 border-b border-gray-300 bg-[#FFFFFF]">
            <div className='flex'>
                <img   onClick={() => {
    if (!token){

       if(user?.role==1){
     navigate('/home');
        }else if(user?.role==2){
  navigate('/dashboard');
        }else{
 navigate('/dashboard');

        }
    } ;
  }}src={logo} alt="Logo" className="w-16 cursor-pointer h-12 mr-4" />
                {location.pathname.includes('/timesheet') && (
        <h1 className="text-[18px] font-bold text-black">Employee Timesheet</h1>
      )}
            </div>
            <div className='flex gap-4 items-center ml-auto'>
                {/* Home Icon */}
                {/* {user?.role === 1 && (
                  <button
                    onClick={() => setAiChatOpen((prev) => !prev)}
                    className="relative flex items-center gap-1.5 px-3 py-1.5 mr-2 rounded-full text-white text-xs font-semibold transition-all duration-200 hover:shadow-lg"
                    style={{
                      background: 'linear-gradient(135deg, #701313 0%, #a52222 100%)',
                      boxShadow: aiChatOpen ? '0 0 12px rgba(112,19,19,0.5)' : '0 2px 8px rgba(112,19,19,0.3)',
                    }}
                  >
                    <AutoAwesomeIcon sx={{ fontSize: 16 }} />
                    <span>AI</span>
                  </button>
                )} */}
                {/* {user?.role === 1 && (
                  <button
                    onClick={() => setAiVectorChatOpen((prev) => !prev)}
                    title="AI Vector Search (test)"
                    className="relative flex items-center gap-1.5 px-3 py-1.5 mr-2 rounded-full text-white text-xs font-semibold transition-all duration-200 hover:shadow-lg"
                    style={{
                      background: 'linear-gradient(135deg, #1a4d7a 0%, #2a78d6 100%)',
                      boxShadow: aiVectorChatOpen ? '0 0 12px rgba(42,120,214,0.5)' : '0 2px 8px rgba(42,120,214,0.3)',
                    }}
                  >
                    <AutoAwesomeIcon sx={{ fontSize: 16 }} />
                    <span>AI Vector</span>
                  </button>
                )} */}
                {isSuperAdmin && !token && (
                  <button
                    onClick={() => setIsApprovalModalOpen(true)}
                    title={
                      pendingApprovals > 0
                        ? `${pendingApprovals} pending approval request${pendingApprovals === 1 ? '' : 's'}`
                        : 'Approval requests'
                    }
                    aria-label={
                      pendingApprovals > 0
                        ? `Approval requests, ${pendingApprovals} pending`
                        : 'Approval requests'
                    }
                    className="relative flex items-center mr-4 text-gray-500 hover:text-[#145388] transition-colors"
                  >
                    <FactCheckRoundedIcon sx={{ width: '20px', height: '20px' }} />
                    {pendingApprovals > 0 && (
                      <span className="absolute -top-1.5 -right-2 flex items-center justify-center min-w-[16px] h-[16px] px-1 bg-red-600 text-white text-[10px] font-semibold rounded-full leading-none">
                        {pendingApprovals > 99 ? '99+' : pendingApprovals}
                      </span>
                    )}
                  </button>
                )}
                <HelpIcon
                sx={{width:"20px"}}
              className={`text-gray-500  cursor-pointer mr-4 ${token ? 'opacity-50 cursor-not-allowed' : ''}`}
                onClick={()=>{
                  navigate('/support')
                }}
                />
             <FaHome
  onClick={() => {
 if (!token){

       if(user?.role==1){
     navigate('/home');
        }else if(user?.role==2){
  navigate('/dashboard');
        }else{
 navigate('/dashboard');

        }
    }
  }}
  className={`text-gray-500 cursor-pointer mr-4 ${token ? 'opacity-50 cursor-not-allowed' : ''}`}
  size={20}
/>
                
                {/* Profile Icon with Dropdown */}
                <div className="relative">
           {imageUrl ? (
  <div className="rounded-full cursor-pointer border-2 border-gray-300 w-8 h-8 overflow-hidden">
    <img
      onClick={toggleProfileMenu}
      src={imageUrl}
      alt="Profile"
      className="w-full h-full object-cover"
    />
  </div>
) : (
  <FaUserCircle
    className="text-gray-500 cursor-pointer"
    size={24}
    onClick={toggleProfileMenu} // <- Add this line
  />
)}


                    {isProfileMenuOpen && (
                        <div 
                            ref={profileMenuRef} // Attach the ref to the dropdown
                            className="absolute right-0 mt-2 p-2 w-36 z-20 bg-white shadow-lg rounded-md border border-gray-300"
                        >
                    <button
  className={`block w-full flex items-center gap-2 text-left p-2 ${
    token ? 'text-gray-400 cursor-not-allowed' : 'text-black hover:bg-gray-200'
  }`}
  onClick={() => {
    if (!token) {
      // setShowModal(true);
      navigate('./profile');
    }
  }}
  disabled={!!token}  // optional: disables the button for accessibility
>
  <FaUserCircle
    className={`text-gray-500 ${token ? 'opacity-50' : ''}`}
    size={18}
  /> 
  Profile
</button>
                            <button
                                className="block w-full flex items-center gap-2 text-left p-2 text-black hover:bg-gray-200"
                                onClick={handleLogout}
                            >
                                  <FaSignOutAlt  className="text-gray-500  cursor-pointer" size={16} />
                                Logout
                            </button>
                        </div>
                    )}
                </div>
            </div>
            <ApprovalRequestsModal
                isOpen={isApprovalModalOpen}
                onClose={() => setIsApprovalModalOpen(false)}
                onActionDone={fetchPendingApprovals}
                showToast={showToast}
            />
            <Toast
                open={toast.open}
                onClose={() => setToast((prev) => ({ ...prev, open: false }))}
                severity={toast.severity}
                message={toast.message}
            />
            <ProfileModal isOpen={showModal} onClose={() => setShowModal(false)} />
            <AiSupportChat open={aiChatOpen} onClose={() => setAiChatOpen(false)} />
            <AiVectorSupportChat open={aiVectorChatOpen} onClose={() => setAiVectorChatOpen(false)} />
        </header>
    );
};

export default MainHeader;
